var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// SPDX-FileCopyrightText: 2025 Enric Badia <enric@xtremis.com>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useNotify } from "react-admin";
import { useTranslation } from "react-i18next";
/**
 * A custom hook that provides a notification function with translation support.
 *
 * This hook wraps the `useNotify` function and integrates it with the `useTranslation`
 * hook to allow for localized notification messages. It ensures that the message
 * is not translated multiple times by providing a fallback message argument.
 *
 * @returns A function to trigger notifications with a translated message.
 *
 * The returned function accepts the following parameters:
 *
 * @param key - The translation key for the notification message.
 * @param options - An object containing notification options.
 * @param options.type - The type of notification, either "success" or "error".
 */
export var useCustomNotify = function () {
    var notify = useNotify();
    var t = useTranslation().t;
    return function (key, options) {
        notify(t(key), __assign(__assign({}, options), { messageArgs: { _: t(key) } }));
    };
};
